import { FilterSortPaginateOption } from "../../../../shared/models";
import { Action } from "@ngrx/store";

export const GET_PROJECT_SCHEDULE = '[Project Schedule] Get Project Schedule';
export const GET_PROJECT_SCHEDULE_SUCCESS = '[Project Schedule] Get Project Schedule Success';
export const GET_PROJECT_SCHEDULE_FAIL = '[Project Schedule] Get Project Schedule Fail';
export const CLEAR_PROJECT_SCHEDULE = '[Project Schedule] Clear Project Schedule';

export class GetProjectSchedule implements Action {
  readonly type = GET_PROJECT_SCHEDULE;
  constructor(public payload: FilterSortPaginateOption) { }
}

export class GetProjectScheduleSuccess implements Action {
  readonly type = GET_PROJECT_SCHEDULE_SUCCESS;
  constructor(public payload: any = null) { }
}

export class GetProjectScheduleFail implements Action {
  readonly type = GET_PROJECT_SCHEDULE_FAIL;
  constructor(public payload: any = null) { }
}

export class ClearProjectSchedule implements Action {
  readonly type = CLEAR_PROJECT_SCHEDULE;
  constructor() { }
}

export type ProjectScheduleActions =
  | GetProjectSchedule
  | GetProjectScheduleSuccess
  | GetProjectScheduleFail
  | ClearProjectSchedule;